export default __webpack_public_path__ + "static/media/arenPro4.3c5f95ff.jpg";